'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Step = React.forwardRef(({ title, index: index$1, onClick, completed, active, ...props }, ref) => (React__default.default.createElement(index.Flex.Row, { ...props, space: "m", ref: ref },
    React__default.default.createElement(styles.Styled.StepBadge, { completed: completed, activeStep: active }, completed ? React__default.default.createElement(component.Icon, { name: "validate-filled" }) : index$1 !== undefined && index$1 + 1),
    React__default.default.createElement(styles.Styled.StepLink, { activeStep: active, isClickable: !!onClick, onClick: () => index$1 !== undefined && onClick?.(index$1) }, title))));

exports.Step = Step;
//# sourceMappingURL=step.js.map
